const METRIC_DISPATCH = 'DISPATCH';
const METRIC_ERROR = 'ERROR';
const METRIC_GQL = 'GQL';
const METRIC_HTTP = 'HTTP';
const METRIC_CONNECTION = 'CONNECTION';
const METRIC_UPDATE_PROPERTIES = 'UPDATE_PROPERTIES';
const METRIC_UPDATE_STATE = 'UPDATE_STATE';
const METRIC_RENDER_START = 'RENDER_START';
const METRIC_RENDER_END = 'RENDER_END';
const METRIC_RENDER_TREE = 'RENDER_TREE';
const METRIC_INTERSECTION = 'INTERSECTION';
const METRIC_SCHEDULE = 'SCHEDULE';
const METRIC_EXECUTE = 'EXECUTE';
const METRIC_DEFER = 'DEFER';
const METRIC_PROPERTY_REFLECTION = 'PROPERTY_REFLECTION';
const METRIC_EFFECT_START = 'EFFECT_START';
const METRIC_EFFECT_END = 'EFFECT_END';
const METRIC_PATCH_START = 'PATCH_START';
const METRIC_PATCH_END = 'PATCH_END';
const METRIC_HOOK_START = 'HOOK_START';
const METRIC_HOOK_END = 'HOOK_END';
const METRIC_INTERACTIVE = 'INTERACTIVE';
const METRIC_HERO_INTERACTIVE = 'HERO_INTERACTIVE';
const METRIC_UPDATE_CONTEXT = 'UPDATE_CONTEXT';
export const LIB_NAME = '@servicenow/ui-metrics';

export const types = {
	DISPATCH: METRIC_DISPATCH,
	ERROR: METRIC_ERROR,
	GQL: METRIC_GQL,
	HTTP: METRIC_HTTP,
	CONNECTION: METRIC_CONNECTION,
	UPDATE_PROPERTIES: METRIC_UPDATE_PROPERTIES,
	UPDATE_STATE: METRIC_UPDATE_STATE,
	RENDER_START: METRIC_RENDER_START,
	RENDER_END: METRIC_RENDER_END,
	RENDER_TREE: METRIC_RENDER_TREE,
	INTERSECTION: METRIC_INTERSECTION,
	SCHEDULE: METRIC_SCHEDULE,
	EXECUTE: METRIC_EXECUTE,
	DEFER: METRIC_DEFER,
	PROPERTY_REFLECTION: METRIC_PROPERTY_REFLECTION,
	EFFECT_START: METRIC_EFFECT_START,
	EFFECT_END: METRIC_EFFECT_END,
	PATCH_START: METRIC_PATCH_START,
	PATCH_END: METRIC_PATCH_END,
	HOOK_START: METRIC_HOOK_START,
	HOOK_END: METRIC_HOOK_END,
	INTERACTIVE: METRIC_INTERACTIVE,
	HERO_INTERACTIVE: METRIC_HERO_INTERACTIVE,
	UPDATE_CONTEXT: METRIC_UPDATE_CONTEXT
};

export const levels = {
	[METRIC_HERO_INTERACTIVE]: 5,
	[METRIC_INTERACTIVE]: 5,
	[METRIC_ERROR]: 5,
	[METRIC_GQL]: 4,
	[METRIC_HTTP]: 4,
	[METRIC_DISPATCH]: 3,
	[METRIC_RENDER_START]: 2,
	[METRIC_RENDER_END]: 2,
	[METRIC_RENDER_TREE]: 2,
	[METRIC_INTERSECTION]: 1,
	[METRIC_CONNECTION]: 1,
	[METRIC_UPDATE_PROPERTIES]: 1,
	[METRIC_UPDATE_STATE]: 1,
	[METRIC_SCHEDULE]: 1,
	[METRIC_EXECUTE]: 1,
	[METRIC_DEFER]: 1,
	[METRIC_PROPERTY_REFLECTION]: 1,
	[METRIC_EFFECT_START]: 0,
	[METRIC_EFFECT_END]: 0,
	[METRIC_PATCH_START]: 0,
	[METRIC_PATCH_END]: 0,
	[METRIC_HOOK_START]: 0,
	[METRIC_HOOK_END]: 0,
	[METRIC_UPDATE_CONTEXT]: 1
};

// Copied from @servicenow/ui-core. This should be in @servicenow/ui-internals, however that package
// depends on this package, which would create a circular dependency
export const SEISMIC_HOIST_TAG_NAME = 'SEISMIC-HOIST';

export const timings = {
	LOWER_BOUNDARY: '0-50ms',
	MIDDLE: '51-100ms',
	UPPER_BOUNDARY: '100+ms'
};
export const timingMetricTypes = {
	DEFER: 'defer',
	DEBOUNCE: 'debounce'
};

export const UNKNOWN_COMPONENT_NAME = 'UNKNOWN';
